import { Helmet } from 'react-helmet-async'
import HomeTemplate from '../templates/HomeTemplate.jsx'
import VideoDownloaderSEO from '../components/ui/VideoDownloaderSEO.jsx'
import { SITE_URL } from '../utils/seo.js'
import { useLanguage } from '../context/LanguageContext.jsx'

const title       = 'YouTube Video Downloader — Free MP4 Download HD & MP3 | FastAudio'
const description = 'Download any YouTube video as MP4 (up to 1080p HD) or MP3 audio (320kbps) — free, no software, no registration. Works on iPhone, Android & PC.'
const canonical   = `${SITE_URL}/youtube-video-downloader`

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: 'Can I download YouTube videos as MP4?',         acceptedAnswer: { '@type': 'Answer', text: 'Yes. FastAudio downloads YouTube videos as MP4 in up to 1080p Full HD.' } },
    { '@type': 'Question', name: 'Is the YouTube downloader completely free?',    acceptedAnswer: { '@type': 'Answer', text: 'Yes, 100% free with no registration, no limits, and no hidden charges.' } },
    { '@type': 'Question', name: 'Does it work on iPhone and Android?',           acceptedAnswer: { '@type': 'Answer', text: 'Yes. FastAudio works in all modern mobile browsers — Safari on iOS and Chrome on Android.' } },
    { '@type': 'Question', name: 'Can I download YouTube Shorts as MP4?',         acceptedAnswer: { '@type': 'Answer', text: 'Yes. YouTube Shorts URLs are fully supported and download as portrait MP4 files.' } },
    { '@type': 'Question', name: 'What is the maximum quality for YouTube MP4?',  acceptedAnswer: { '@type': 'Answer', text: 'FastAudio supports up to 1080p Full HD for YouTube MP4 downloads.' } },
  ],
}

const howToSchema = {
  '@context': 'https://schema.org',
  '@type': 'HowTo',
  name: 'How to Download YouTube Videos as MP4',
  step: [
    { '@type': 'HowToStep', name: 'Copy YouTube URL',    text: 'Copy the video URL from your browser or the YouTube app.' },
    { '@type': 'HowToStep', name: 'Paste into FastAudio',text: 'Paste the URL into the search box on FastAudio.' },
    { '@type': 'HowToStep', name: 'Select MP4 quality',  text: 'Choose your desired video resolution (360p, 480p, 720p, or 1080p).' },
    { '@type': 'HowToStep', name: 'Click Download',      text: 'Hit the ⚡ Download button — the file saves to your device.' },
  ],
}

export default function YouTubeVideoDownloader() {
  const { t } = useLanguage()
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <meta property="og:title"       content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url"         content={canonical} />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(howToSchema)}</script>
      </Helmet>
      <HomeTemplate
        provider="youtube"
        title={title}
        description={description}
        canonical={canonical}
        badge="YouTube Video Downloader"
        heading={<>YouTube Video <span className="text-gradient">Downloader</span></>}
        subheading="Download any YouTube video as MP4 (up to 1080p HD) or MP3 audio (up to 320kbps) — free, no registration, works on all devices."
        placeholder={t('ytPlaceholder')}
      >
        <VideoDownloaderSEO provider="youtube" />
      </HomeTemplate>
    </>
  )
}
